import { computed as c, openBlock as o, createBlock as s, unref as d, normalizeClass as l, withCtx as p, createElementVNode as u, toDisplayString as r, createElementBlock as g } from "vue";
import { tagColors as w } from "../../constants/colors.js";
/* empty css         */
import e from "../anchor-element/anchor-element.vue.js";
const m = { class: "ds-tag__text" }, f = /* @__PURE__ */ Object.assign({
  name: "DsTag"
}, {
  __name: "tag",
  props: {
    label: { type: String, default: "" },
    color: { type: String, default: "grey", validator: (a) => !a || w.includes(a) },
    link: { type: String, default: "" },
    trackingData: e.props.trackingData,
    openInNewWindow: e.props.openInNewWindow,
    nuxt: e.props.nuxt,
    prefetch: e.props.prefetch,
    ariaLabel: e.props.ariaLabel,
    download: e.props.download
  },
  setup(a) {
    const t = a, n = c(() => t.color ? `ds-tag--${t.color}` : null);
    return (i, k) => a.link ? (o(), s(d(e), {
      key: 0,
      url: a.link,
      "tracking-data": { "component-name": i.$options.name, ...a.trackingData },
      "open-in-new-window": a.openInNewWindow,
      nuxt: a.nuxt,
      prefetch: a.prefetch,
      "aria-label": a.ariaLabel,
      download: a.download,
      class: l(["ds-tag ds-tag--with-link", [n.value]])
    }, {
      default: p(() => [
        u("span", m, r(a.label), 1)
      ]),
      _: 1
    }, 8, ["url", "tracking-data", "open-in-new-window", "nuxt", "prefetch", "aria-label", "download", "class"])) : (o(), g("span", {
      key: 1,
      class: l(["ds-tag", [n.value]])
    }, r(a.label), 3));
  }
}), D = f;
export {
  D as default
};
